var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"error-page",attrs:{"id":"wrapper"}},[_c('div',{staticClass:"error-box"},[_c('div',{staticClass:"error-body text-center"},[_c('h3',{staticClass:"text-uppercase bold mx-3 mt-5"},[_vm._v("TRANG WEB ĐANG ĐƯỢC BẢO TRÌ, NÂNG CẤP")]),_c('h5',{staticClass:"text-muted my-4"},[_vm._v("Vui lòng thử lại sau ít phút")])])])])])
}]

export { render, staticRenderFns }